<ng-container *transloco="let t;">
    <div class="content-header">
        <h1 class="mb-0">{{t('Onboarding tellUsAboutYourself heading - Tell us about yourself')}}</h1>
        <p class="subtitle-text">{{t('Onboarding tellUsAboutYourself subtitle - What kind of work do you do?')}}
        </p>
    </div>
    <div class="form-group tell-us-about-you-container">
        <div class="button-grid-container">
            <span class="select-one-text">{{t('Onboarding tellUsAboutYourself selectOne - Select
                one:')}}</span>
            <span class="hide-on-mobile"></span>
            <ng-container *ngFor="let workTypeOption of workTypeList">
                <button type="button" class="role-button"
                    (click)="onWorkTypeSelect(workTypeOption.name)">{{t('Onboarding jobTitle ' + workTypeOption.name + '
                    - ' + workTypeOption.name)}}</button>
            </ng-container>
        </div>
    </div>
</ng-container>